// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__BxEoH","content":"styles_content__YTxru","checkbox":"styles_checkbox__s98S3","checkboxLabel":"styles_checkboxLabel__1m11g"};